var v = require("validator");
var enums = require("./validationEnums");
var moment = require("moment");

export default {
  propertiesValidator(fieldsToValidate) {
    return new Promise((resolve, reject) => {
      if (Object.keys(fieldsToValidate).length === 0 && fieldsToValidate.constructor === Object) return {};
      // Init fields with the proper mechanisem for validation
      var initiatedData = initUpdateArrFromJson(fieldsToValidate);

      var err = "";
      var validatedData = {};
      var erredData = {};
      for (const field of initiatedData) {
        err = "";
        // if (err) break;
        if (!field.data && field.allowEmptyVal) {
          validatedData[field.fieldTag] = "";
          continue;
        }
        if (!field.data && field.notMandatory) continue;
        if (!field.data || (field.type !== enums.NUMBER && v.isEmpty(field.data))) {
          err = `Field cant be empty.`;
          erredData[field.fieldTag] = err;
          continue;
        }
        // Xu - can be accepted here as a name for example.
        if (field.type !== enums.NUMBER && !v.isLength(field.data, 2, 500)) {
          err = `Field got a forbidden length.`;
          erredData[field.fieldTag] = err;
          continue;
        }
        switch (field.type) {
          case enums.EMAIL:
            if (!v.isEmail(field.data)) {
              err = `הפורמט של האימייל אינו תקין`;
              erredData[field.fieldTag] = err;
            }
            field.data = field.data.toLowerCase();
            validatedData[field.fieldTag] = field.data;
            break;
          case enums.PASSWORD:
            if (!v.isLength(field.data, 6, 25)) {
              err = `Password must be at least 6 characters`;
              erredData[field.fieldTag] = err;
            }
            validatedData[field.fieldTag] = field.data;
            break;
          case enums.NAME:
            validatedData[field.fieldTag] = field.data;
            break;
          case enums.GENDER:
            if (field.data !== "male" && field.data !== "female") {
              err = `Field of type gender can be only set to 'male' or 'female`;
              erredData[field.fieldTag] = err;
            }
            validatedData[field.fieldTag] = field.data;
            break;
          case enums.MOBILE:
            if (!v.isLength(field.data, 8, 16)) {
              err = `Field of type mobile got a forbidden length`;
              erredData[field.fieldTag] = err;
            }
            // should not reject +972...
            else if (!v.isNumeric(field.data)) {
              err = `Field of type mobile is not numeric`;
              erredData[field.fieldTag] = err;
            }
            validatedData[field.fieldTag] = field.data;
            break;
          case enums.DATE:
            if (!moment(field.data, "DD/MM/YYYY").isValid()) {
              err = `Not a valid date format`;
              erredData[field.fieldTag] = err;
            }
            validatedData[field.fieldTag] = field.data;
            break;
          case enums.DATE_FUTURE:
            if (!moment(field.data, "DD/MM/YYYY").isValid()) {
              err = `Not a valid date format`;
              erredData[field.fieldTag] = err;
            }
            if (moment(field.data, "DD/MM/YYYY").isBefore(moment(new Date()))) {
              err = "The date must be in the future";
              erredData[field.fieldTag] = err;
            }
            break;
          case enums.NUMBER:
            if (isNaN(field.data)) {
              // Type string
              if (!v.isNumeric(field.data)) {
                err = `Field not numeric`;
                erredData[field.fieldTag] = err;
              } else {
                // type string but number format
                validatedData[field.fieldTag] = parseFloat(field.data);
              }
            } else {
              // if its indeed a real number
              validatedData[field.fieldTag] = field.data;
            }
            break;
          case enums.CLIENT_TYPE:
            if (field.data !== "Donor" && field.data !== "Patient") {
              err = `Field of clientType was set to - ${field.data} => not a valid clientType`;
              erredData[field.fieldTag] = err;
            } else {
              validatedData[field.fieldTag] = field.data;
            }
            break;
          case enums.BLOOD_TYPE:
            if (field.data !== "A" && field.data !== "B" && field.data !== "AB" && field.data !== "O") {
              err = "Wrong blood type format";
              erredData[field.fieldTag] = err;
            } else {
              validatedData[field.fieldTag] = field.data;
            }
            break;

          case enums.IGNORE:
            validatedData[field.fieldTag] = field.data;
            break;

          default:
            break;
        }
      }

      if (!(Object.keys(erredData).length === 0 && erredData.constructor === Object)) reject(erredData);
      else resolve({ validatedData });
    });
  }
};

function initUpdateArrFromJson(newData) {
  var arrOfData = [];
  if (newData.hasOwnProperty("firstName")) {
    arrOfData.push({ data: newData.firstName, type: enums.NAME, fieldTag: "firstName" });
  }
  if (newData.hasOwnProperty("lastName")) {
    arrOfData.push({ data: newData.lastName, type: enums.NAME, fieldTag: "lastName" });
  }
  if (newData.hasOwnProperty("gender")) {
    arrOfData.push({ data: newData.gender, type: enums.GENDER, fieldTag: "gender" });
  }
  if (newData.hasOwnProperty("secondEmail")) {
    arrOfData.push({ data: newData.secondEmail, type: enums.EMAIL, fieldTag: "secondEmail" });
  }
  if (newData.hasOwnProperty("mobile")) {
    arrOfData.push({ data: newData.mobile, type: enums.MOBILE, fieldTag: "mobile" });
  }
  if (newData.hasOwnProperty("cityAndState")) {
    arrOfData.push({ data: newData.cityAndstate, type: enums.NAME, fieldTag: "cityAndState" });
  }
  if (newData.hasOwnProperty("zipcode")) {
    arrOfData.push({ data: newData.zipcode, type: enums.NUMBER, fieldTag: "zipcode" });
  }
  if (newData.hasOwnProperty("aptname")) {
    arrOfData.push({ data: newData.aptname, type: enums.NAME, fieldTag: "aptname" });
  }
  if (newData.hasOwnProperty("street")) {
    arrOfData.push({ data: newData.street, type: enums.NAME, fieldTag: "street" });
  }
  if (newData.hasOwnProperty("country")) {
    arrOfData.push({ data: newData.country, type: enums.NAME, fieldTag: "country" });
  }
  if (newData.hasOwnProperty("birthday")) {
    arrOfData.push({ data: newData.birthday, type: enums.DATE, fieldTag: "birthday" });
  }
  if (newData.hasOwnProperty("email")) {
    arrOfData.push({ data: newData.email, type: enums.EMAIL, fieldTag: "email" });
  }
  if (newData.hasOwnProperty("password")) {
    arrOfData.push({ data: newData.password, type: enums.PASSWORD, fieldTag: "password" });
  }
  if (newData.hasOwnProperty("clientType")) {
    arrOfData.push({ data: newData.clientType, type: enums.CLIENT_TYPE, fieldTag: "clientType" });
  }
  if (newData.hasOwnProperty("referredBy")) {
    arrOfData.push({ data: newData.referredBy, type: enums.EMAIL, fieldTag: "referredBy", notMandatory: true });
  }
  if (newData.hasOwnProperty("nationality")) {
    arrOfData.push({ data: newData.nationality, type: enums.NAME, fieldTag: "nationality", allowEmptyVal: true });
  }
  if (newData.hasOwnProperty("passportNumber")) {
    arrOfData.push({ data: newData.passportNumber, type: enums.NAME, fieldTag: "passportNumber", allowEmptyVal: true });
  }
  if (newData.hasOwnProperty("age")) {
    arrOfData.push({ data: newData.age, type: enums.NUMBER, fieldTag: "age", allowEmptyVal: true });
  }
  if (newData.hasOwnProperty("height")) {
    arrOfData.push({ data: newData.height, type: enums.NUMBER, fieldTag: "height", allowEmptyVal: true });
  }
  if (newData.hasOwnProperty("weight")) {
    arrOfData.push({ data: newData.weight, type: enums.NUMBER, fieldTag: "weight", allowEmptyVal: true });
  }
  if (newData.hasOwnProperty("partnerRelationship")) {
    arrOfData.push({
      data: newData.partnerRelationship,
      type: enums.NAME,
      fieldTag: "partnerRelationship",
      allowEmptyVal: true
    });
  }
  if (newData.hasOwnProperty("hemoglobin")) {
    arrOfData.push({ data: newData.hemoglobin, type: enums.NAME, fieldTag: "hemoglobin", allowEmptyVal: true });
  }
  if (newData.hasOwnProperty("platelets")) {
    arrOfData.push({ data: newData.platelets, type: enums.NAME, fieldTag: "platelets", allowEmptyVal: true });
  }
  if (newData.hasOwnProperty("sodium")) {
    arrOfData.push({ data: newData.sodium, type: enums.NAME, fieldTag: "sodium", allowEmptyVal: true });
  }
  if (newData.hasOwnProperty("potassium")) {
    arrOfData.push({ data: newData.potassium, type: enums.NAME, fieldTag: "potassium", allowEmptyVal: true });
  }
  if (newData.hasOwnProperty("urea")) {
    arrOfData.push({ data: newData.urea, type: enums.NAME, fieldTag: "urea", allowEmptyVal: true });
  }
  if (newData.hasOwnProperty("creatinine")) {
    arrOfData.push({ data: newData.creatinine, type: enums.NAME, fieldTag: "creatinine", allowEmptyVal: true });
  }
  if (newData.hasOwnProperty("glucose")) {
    arrOfData.push({ data: newData.glucose, type: enums.NAME, fieldTag: "glucose", allowEmptyVal: true });
  }
  if (newData.hasOwnProperty("hemoglobinA1C")) {
    arrOfData.push({ data: newData.hemoglobinA1C, type: enums.NAME, fieldTag: "hemoglobinA1C", allowEmptyVal: true });
  }
  if (newData.hasOwnProperty("bloodType")) {
    arrOfData.push({ data: newData.bloodType, type: enums.BLOOD_TYPE, fieldTag: "bloodType", allowEmptyVal: true });
  }
  if (newData.hasOwnProperty("officeName")) {
    arrOfData.push({ data: newData.officeName, type: enums.NAME, fieldTag: "officeName" });
  }

  return arrOfData;
}
